export default __webpack_public_path__ + "static/media/exitFlag.2d95483e.svg";